import { Component, Input, OnInit } from "@angular/core";
import { ActivityService } from "@rubbl-activity";
import { MarketingCard } from "@rubbl-marketing";

@Component({
  selector: "app-getting-started-card",
  templateUrl: "./getting-started-card.component.html",
  styleUrls: ["./getting-started-card.component.scss"],
})
export class GettingStartedCardComponent implements OnInit {
  @Input() image: string;
  @Input() header: string;
  @Input() subheader: string;
  @Input() capability: "Renter" | "Owner" | "Affiliate";
  @Input() gettingStartedCards: MarketingCard[];
  @Input() hide: boolean;

  constructor(private activityService: ActivityService) {}

  ngOnInit(): void {
    if (this.hide == null) {
      this.hide = this.activityService.initialActivitiesAreComplete(this.capability);
    }
  }
}
